<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="150" :loading="loading" class="light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table id="exportTransfer" :mobile-breakpoint="0" :headers="headers" :items="planTransferHistory" hide-default-footer class="elevation-1">
        <template v-slot:item.fromCustomer="{ item }"> {{ item.from.user.firstnameEn }} {{ item.from.user.lastnameEn }} </template>
        <template v-slot:item.fromPhone="{ item }">
          {{ item.from.user.phone }}
        </template>
        <template v-slot:item.fromOrder="{ item }">
          {{ item.from.subscription.order_number }}
        </template>

        <template v-slot:item.toCustomer="{ item }"> {{ item.to.user.firstnameEn }} {{ item.to.user.lastnameEn }} </template>
        <template v-slot:item.toPhone="{ item }">
          {{ item.to.user.phone }}
        </template>
        <template v-slot:item.toOrder="{ item }">
          {{ item.to.subscription.order_number }}
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
export default {
  props: {
    planTransferHistory: {
      required: true,
    },
    headers: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      options: {
        itemsPerPage: 25,
        page: 1,
      },
    };
  },
  created() {},

  methods: {
    exportExcel() {
      this.loading = true;
      Utils.htmlToExcel("exportTransfer", "Transfer", false);

      this.loading = false;
    },
  },
};
</script>
